/* eslint no-param-reassign: 0 */

import { NON_LHI_SOURCES } from 'config/constants';

const getLineItemsFromExceptionData = (newItems) => {
  const simplifiedList = [];
  newItems.forEach(item => simplifiedList.push(item.phase_line_item));
  return simplifiedList;
};

export const getRandomNegativeInt = () =>
  Math.floor((Math.random() * ((-1 - -999) + 1)) + -999);

export const getNewLineItem = () => {
  const newId = (new Date().getUTCMilliseconds()) * -1;
  return { id: newId };
};

export const getIndexOfLineItem = (lineItems, id) =>
  lineItems.findIndex(n => n.id === id);

export const updateLineItemsOnCreateHelper = (lineItems, payload) => {
  lineItems[lineItems.length - 1] = payload.line_item;
  lineItems.push(getNewLineItem());
};

export const updateOnCreateExceptionHelper = (lineItems, payload, listName) => {
  if (listName === 'phaseLineItems') {
    const newItems = getLineItemsFromExceptionData(payload.line_items);
    newItems.forEach((item) => { lineItems[lineItems.length - 1] = item; });
  } else {
    lineItems[lineItems.length - 1] = payload.po.purchase_order;
  }
  lineItems.push(getNewLineItem());
};

export const updateLineItemsOnUpdateHelper = (lineItems, payload) => {
  const indexOfLineItem = getIndexOfLineItem(lineItems, payload.line_item.id);
  lineItems[indexOfLineItem] = payload.line_item;
};

export const addLineItemErrorHelper = (lineItems, payload) => {
  const indexOfLineItem = getIndexOfLineItem(lineItems, payload.line_item.id);
  lineItems[indexOfLineItem].errors = payload.errors.errors;
};

export const addLineItemEventsHelper = (lineItems, payload) => {
  const indexOfLineItem = getIndexOfLineItem(lineItems, payload.line_item.id);
  lineItems[indexOfLineItem].events = payload.events;
};

export const deleteLineItemHelper = (lineItems, id) => {
  const indexOfLineItem = getIndexOfLineItem(lineItems, id);
  lineItems.splice(indexOfLineItem, 1);
};

export const calculateTotal = (price, quantity) => {
  const priceFloat = parseFloat(price);
  const quantityFloat = parseFloat(quantity);

  if (isNaN(priceFloat) || isNaN(quantityFloat)) {
    return 0;
  }
  return Math.round((priceFloat * quantityFloat) * 100) / 100;
};

export const cutQuantityString = (cutObject) => {
  const { packages, remainder } = cutObject;
  const padString = packages ? `${packages} roll(s)` : '';
  const feetString = remainder || !padString ? `${remainder} feet` : '';
  const addString = padString && feetString ? ' + ' : '';
  return `${padString}${addString}${feetString}`;
};

export const formatDollars = value => `$${parseFloat(value || 0).toFixed(2)}`;

export const filterByVendor = (lineItemOptions, phaseSource) => {
  if (NON_LHI_SOURCES.includes(phaseSource || '')) {
    return lineItemOptions.filter(o => o.vendor === phaseSource);
  }
  return lineItemOptions.filter(o => !NON_LHI_SOURCES.includes(o.vendor || ''));
};

/**
 * payRateLineItems.data is { [laborSheetId]: options[] } (see pay_rate_line_items reducer).
 * Callers may also pass an already-normalized array.
 */
export const normalizePayRateLineItemOptions = (payData, laborSheets) => {
  const sheets = laborSheets || [];
  if (payData == null) return [];
  if (Array.isArray(payData)) return payData;
  if (typeof payData !== 'object') return [];

  const preferNonEmpty = (arrays) => {
    const valid = arrays.filter(Array.isArray);
    const withItems = valid.find(a => a.length > 0);
    if (withItems) return withItems;
    return valid[0];
  };

  const fromSheets = preferNonEmpty(sheets.map(s => payData[s.id]));
  if (fromSheets !== undefined) return fromSheets;

  const fromValues = preferNonEmpty(Object.values(payData));
  return fromValues !== undefined ? fromValues : [];
};



// WEBPACK FOOTER //
// ./client/app/utils/lineItemUtils.js